/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ControlDto } from './ControlDto';
import {
    ControlDtoFromJSON,
    ControlDtoFromJSONTyped,
    ControlDtoToJSON,
    ControlDtoToJSONTyped,
} from './ControlDto';

/**
 * 
 * @export
 * @interface GroupExtendedDto
 */
export interface GroupExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof GroupExtendedDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupExtendedDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupExtendedDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupExtendedDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupExtendedDto
     */
    groupClass?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupExtendedDto
     */
    catalogId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupExtendedDto
     */
    catalogName?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupExtendedDto
     */
    parentGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupExtendedDto
     */
    parentGroupName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupExtendedDto
     */
    hasControls?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupExtendedDto
     */
    hasSubGroups?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GroupExtendedDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupExtendedDto
     */
    updated?: Date;
    /**
     * 
     * @type {Array<ControlDto>}
     * @memberof GroupExtendedDto
     */
    controls?: Array<ControlDto>;
}

/**
 * Check if a given object implements the GroupExtendedDto interface.
 */
export function instanceOfGroupExtendedDto(value: object): value is GroupExtendedDto {
    return true;
}

export function GroupExtendedDtoFromJSON(json: any): GroupExtendedDto {
    return GroupExtendedDtoFromJSONTyped(json, false);
}

export function GroupExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'groupClass': json['groupClass'] == null ? undefined : json['groupClass'],
        'catalogId': json['catalogId'] == null ? undefined : json['catalogId'],
        'catalogName': json['catalogName'] == null ? undefined : json['catalogName'],
        'parentGroupId': json['parentGroupId'] == null ? undefined : json['parentGroupId'],
        'parentGroupName': json['parentGroupName'] == null ? undefined : json['parentGroupName'],
        'hasControls': json['hasControls'] == null ? undefined : json['hasControls'],
        'hasSubGroups': json['hasSubGroups'] == null ? undefined : json['hasSubGroups'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'controls': json['controls'] == null ? undefined : ((json['controls'] as Array<any>).map(ControlDtoFromJSON)),
    };
}

export function GroupExtendedDtoToJSON(json: any): GroupExtendedDto {
    return GroupExtendedDtoToJSONTyped(json, false);
}

export function GroupExtendedDtoToJSONTyped(value?: GroupExtendedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'groupId': value['groupId'],
        'title': value['title'],
        'description': value['description'],
        'groupClass': value['groupClass'],
        'catalogId': value['catalogId'],
        'catalogName': value['catalogName'],
        'parentGroupId': value['parentGroupId'],
        'parentGroupName': value['parentGroupName'],
        'hasControls': value['hasControls'],
        'hasSubGroups': value['hasSubGroups'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'controls': value['controls'] == null ? undefined : ((value['controls'] as Array<any>).map(ControlDtoToJSON)),
    };
}

